import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

/**
 * Centralized typed access to environment variables for code bundled by Vite
 * (client, SSR, and TanStack Start server functions).
 *
 * `createEnv` validates at module-load time and throws a readable error if a
 * required variable is missing or malformed — so a misconfigured deployment
 * fails fast on the first request instead of silently no-op-ing on `undefined`.
 *
 * Import from this module instead of touching `import.meta.env` or `process.env`
 * directly. The only intentional exception is `middleware.ts` at the project
 * root, which is bundled by Vercel for the Edge runtime (no Vite, no
 * `import.meta.env`) and must keep reading `process.env` directly.
 */
export const env = createEnv({
  client: {
    VITE_CONVEX_URL: z.string().url(),
    VITE_DEV_LOGIN: z.string().optional(),
    VITE_PUBLIC_SITE_HOST: z.string().optional(),
    VITE_SENTRY_DSN: z.string().url().optional(),
    VITE_VERCEL_ENV: z
      .enum(["production", "preview", "development"])
      .optional(),
  },
  clientPrefix: "VITE_",
  emptyStringAsUndefined: true,
  runtimeEnv: {
    VITE_CONVEX_URL: import.meta.env.VITE_CONVEX_URL,
    VITE_DEV_LOGIN: import.meta.env.VITE_DEV_LOGIN,
    VITE_PUBLIC_SITE_HOST: import.meta.env.VITE_PUBLIC_SITE_HOST,
    VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    VITE_VERCEL_ENV: import.meta.env.VITE_VERCEL_ENV,
  },
});
